const TOKEN = /\{\{([A-Za-z0-9_]+)\}\}/g;

export function extractTokens(html) {
  return [...new Set([...html.matchAll(TOKEN)].map((m) => m[1]))];
}

/** Returns an array of human-readable problems. Empty array = OK to save. */
export function validateDocument(html, allowed) {
  const errors = [];
  const text = html.replace(/<[^>]*>/g, '');

  if (/\{%/.test(text) || /\{%/.test(html)) errors.push('Template tag "{%" is not allowed.');
  if (/\{#/.test(text) || /\{#/.test(html)) errors.push('Comment tag "{#" is not allowed.');

  const unknown = extractTokens(html).filter((t) => !allowed.has(t));
  if (unknown.length) errors.push(`Unknown token(s): ${unknown.map((t) => `{{${t}}}`).join(', ')}.`);

  const rawCount = (html.match(TOKEN) || []).length;
  const textCount = (text.match(TOKEN) || []).length;
  if (textCount > rawCount) {
    errors.push('A token is split by formatting. Select the whole token and clear formatting, or retype it.');
  }

  const leftover = text.replace(TOKEN, '').replace(/\{[%#]/g, '');
  if (/[{}]/.test(leftover)) {
    errors.push('Unbalanced or malformed braces. Tokens must look like {{name}} using letters, digits or underscore.');
  }

  const doc = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
  doc.querySelectorAll('.room-details').forEach((n) => n.remove());
  if (/\{\{\s*room_details\s*\}\}/.test(doc.body.textContent)) {
    errors.push('{{room_details}} cannot be typed by hand. Insert it from the Fields menu.');
  }
  return errors;
}
